import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { blue } from '@material-ui/core/colors/';
import { APITextField } from '../../components/APITextField';
import { APISelectField } from '../../components/APISelectField';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { addLicenseType } from '../../services/service';
import { FaListAlt } from 'react-icons/fa';
import MenuItem from '@mui/material/MenuItem';
import './ListPageStyles.css'
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import FormGroup from "@material-ui/core/FormGroup";
import { FormDialog } from '../../components/FormDialog';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


const ColorButton = styled(Button)(({ theme }) => ({
  color: 'white',
  backgroundColor: blue[700],
  '&:hover': {
    backgroundColor: blue[900],
  },
}));

const validationSchema = Yup.object({
  name: Yup
    .string('Insira o nome do Modelo da Licença')
    .required('Campo obrigatório'),
  durationUnit: Yup.string()
    .oneOf(['lifetime', 'years', 'months', 'days'])
    .required('Necessário escolher a unidade da duração!'),
})

export default function BtnAddLicenseType({ onLicenseCreated, sx }) {
  const [open, setOpen] = useState(false);
  const [errors, setErrors] = useState();
  const [loading, setLoading] = useState(false);

  const handleClickOpen = () => {
    setErrors(undefined);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      durationUnit: "lifetime",
      types: [],
      max_tags: null,
      scan_rate: null,
      max_control_loops: null,
      max_anomalies: null,
      calc_frequency_anomaly: null,
      max_forecasts: null,
      calc_frequency_forecast: null,
    },
    validationSchema: validationSchema,
  })

  const onSubmit = (values) => {
    setLoading(true)
    const config = {
      historian: {
        max_tags: formik.values.max_tags,
        scan_rate: formik.values.scan_rate,
      },
      pid: {
        max_control_loops: formik.values.max_control_loops
      },
      anomaly: {
        max_anomalies: formik.values.max_anomalies,
        calc_frequency: formik.values.calc_frequency_anomaly
      },
      forecast: {
        max_forecasts: formik.values.max_forecasts,
        calc_frequency: formik.values.calc_frequency_forecast
      }
    }
  
    addLicenseType(
      formik.values.name,
      formik.values.description,
      formik.values.durationValue,
      formik.values.durationUnit,
      formik.values.types,
      config
    ).then((response) => {
      console.log(response['status'])
      if (response.status === 201) {
        handleClose()
        onLicenseCreated()
        formik.resetForm()
      } else {
        console.log(response.data)
      }
    }).finally((resp) => {
      setLoading(false)
    })

  }

  const licenseTypesOptions = [
    { label: "Historian", value: "historian" },
    { label: "PID", value: "pid" },
    { label: "AIoT-Anomaly", value: "anomaly" },
    { label: "AIoT-Forecast", value: "forecast" },
  ]


  return (
    <Box sx={sx}>
      <ColorButton
        startIcon={<FaListAlt />}
        onClick={handleClickOpen}
        size="larger" variant="contained"
        sx={{ padding: 2, width: "100%" }}
      >
        Adicionar modelo de licença
      </ColorButton>
      <FormDialog
        title={"Criar Modelo de Licença"}
        open={open}
        onDismiss={handleClose}
        onSubmit={onSubmit}
        formWidth={500}
        loading={loading}
      >
        <APITextField
          id="license-type-name"
          name="name"
          label="Nome"
          disabled={loading}
          value={formik.values.name}
          onChange={formik.handleChange}
          errors={errors?.name}
          variant="standard"
          style={{ width: "100%", margin: '0.5rem 0rem' }}
        />
        <APITextField
          id="license-type-description"
          label="Descrição"
          name="description"
          multiline
          disabled={loading}
          value={formik.values.description}
          onChange={formik.handleChange}
          errors={errors?.description}
          variant="standard"
          style={{ width: "100%", margin: '0.5rem 0rem' }}
        />
        <Typography align='center' style={{ margin: '0.5rem' }}>
          Duração
        </Typography>
        <FormGroup row>
          <Row>
            <Col>
              <APITextField
                id="license-type-duration-value"
                label=""
                name="durationValue"
                placeholder='Qtde'
                type="number"
                // style={{ width: "100%", paddingRight: "0.5rem" }}
                disabled={loading || formik.values.durationUnit === "lifetime"}
                value={formik.values.durationValue}
                onChange={formik.handleChange}
                errors={errors?.durationValue}
                variant="outlined"
                InputLabelProps={{
                  shrink: false
                }}
              />
            </Col>
            <Col>
              <APISelectField
                id="license-type-duration-unit"
                name="durationUnit"
                // sx={{ width: "100%", paddingRight: "0.5rem" }}
                variant="outlined"
                value={formik.values.durationUnit}
                onChange={formik.handleChange}
                defaultValue={"lifetime"}
                label=""
                disabled={loading}
              >
                <MenuItem value="lifetime" selected>Vitalícia</MenuItem>
                <MenuItem value="years">Anos</MenuItem>
                <MenuItem value="months">Meses</MenuItem>
                <MenuItem value="days">Dias</MenuItem>
              </APISelectField>
            </Col>
          </Row>
        </FormGroup>
        <Typography align='center' style={{ marginTop: '1rem' }}>
          Produto
        </Typography>
        <FormGroup row>
          <div style={{ margin: 'auto' }}>
            {licenseTypesOptions.map(opt => (
              <FormControlLabel
                control={<Checkbox onChange={formik.handleChange} />}
                label={opt.label}
                value={opt.value}
                key={opt.value}
                name="types"
              />
            ))}
          </div>
        </FormGroup>
        <Row>
          <Col>
            <APITextField
              id="license-type-max-tags"
              label="Máximo de Tags"
              name="max_tags"
              placeholder='Qtde'
              type="number"
              disabled={loading || !formik.values.types.includes("historian")}
              value={formik.values.max_tags}
              onChange={formik.handleChange}
              errors={errors?.max_tags}
              variant="standard"
            />
          </Col>
          <Col>
            <APITextField
              id="license-type-scan-rate"
              label="Taxa de Coleta Mínima"
              name="scan_rate"
              placeholder='segundos'
              type="number"
              disabled={loading || !formik.values.types.includes("historian")}
              value={formik.values.scan_rate}
              onChange={formik.handleChange}
              errors={errors?.scan_rate}
              variant="standard"
            />
          </Col>
          <Col>
            <APITextField
              id="license-type-max-control-loops"
              label="Máximo de Malhas"
              name="max_control_loops"
              placeholder='Qtde'
              type="number"
              disabled={loading || !formik.values.types.includes("pid")}
              value={formik.values.max_control_loops}
              onChange={formik.handleChange}
              errors={errors?.max_control_loops}
              variant="standard"
            />
          </Col>
        </Row>
        <Row>
        <Col>
            <APITextField
              id="license-type-max-anomalies"
              label="Máximo de Anomalias"
              name="max_anomalies"
              placeholder='Qtde'
              type="number"
              disabled={loading || !formik.values.types.includes("anomaly")}
              value={formik.values.max_anomalies}
              onChange={formik.handleChange}
              errors={errors?.max_anomalies}
              variant="standard"
            />
          </Col>
          <Col>
            <APITextField
              id="license-type-calc-window"
              label="Frequência de Calculos"
              name="calc_frequency_anomaly"
              placeholder='minutos'
              type="number"
              disabled={loading || !formik.values.types.includes("anomaly")}
              value={formik.values.calc_frequency_anomaly}
              onChange={formik.handleChange}
              errors={errors?.calc_frequency_anomaly}
              variant="standard"
            />
          </Col>
          <Col>
            <APITextField
              id="license-type-max-forecasts"
              label="Máximo de Predições"
              name="max_forecasts"
              placeholder='Qtde'
              type="number"
              disabled={loading || !formik.values.types.includes("forecast")}
              value={formik.values.max_forecasts}
              onChange={formik.handleChange}
              errors={errors?.max_forecasts}
              variant="standard"
            />
          </Col>
          <Col>
            <APITextField
              id="license-type-calc-window"
              label="Frequência de Calculos"
              name="calc_frequency_forecast"
              placeholder='minutos'
              type="number"
              disabled={loading || !formik.values.types.includes("forecast")}
              value={formik.values.calc_frequency_forecast}
              onChange={formik.handleChange}
              errors={errors?.calc_frequency_forecast}
              variant="standard"
            />
          </Col>
        </Row>
      </FormDialog>
    </Box >
  );
}